import * as types from './constants';

const initialState = {
  data: [],
  loading: false,
  errors_api: {},
  errorStatus: null
};

const actions = {
  // Get Similar Creators
  [types.GET_SIMILAR_CREATORS_REQUEST]: state => {
    const data = {
      ...state,
      loading: true,
      errors_api: {},
      errorStatus: null
    };

    return { ...data };
  },

  [types.GET_SIMILAR_CREATORS_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      data: payload,
      errors_api: {},
      errorStatus: null
    };

    return { ...data };
  },

  [types.GET_SIMILAR_CREATORS_FAILED]: (state, { payload }) => {
    const nextErrors = payload?.errors_api || payload || {};
    const nextErrorStatus = payload?.status || null;

    const data = {
      ...state,
      loading: false,
      errors_api: nextErrors,
      errorStatus: nextErrorStatus
    };

    return { ...data };
  },

  [types.GET_SIMILAR_CREATORS_RESET]: () => {
    const data = {
      ...initialState
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};

